import { render, staticRenderFns } from "./AddTemplateDialog.vue?vue&type=template&id=d1d130c6"
import script from "./AddTemplateDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddTemplateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./AddTemplateDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports